import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { formatTextFloat } from '../../../helpers/Text';
import { connect } from 'react-redux';
import { REDUCER_NAME } from '../reducer';
import Icon2 from './icon/icon-pen-2';
import { checkZerroInputValuationTool } from '../../../helpers/Text';
import './index.scss';
import { COMPONENT_RESIZE } from '../../../common/GoldenLayoutWrapper';
import Const from './Const';
import ConstVal from './../Const';
import HeaderMethod from './common/HeaderMethod';
import CalculateResult from './common/CalculateResult';
import InputError from './common/InputError';
import { parseIntComma } from '../helpers';

class PB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eoyStockPrice: '',
      ennOfNextYearStockPrice: '',

      estimateBookValuedEOY: 0,
      bookValueForecast: 0,
      estimateBookValuedEoyValidate: true,
      bookValueForecastValidate: true,
      estimateBookValuedEoyError: '',
      bookValueForecastError: '',

      pbMultiple: 4000,
      infoError: '',
      organCode: props.valuationStock.organCode,

      bottom: null,
    };
    this.calculatePB.bind(this);
    this.estimateBookValuedEOY = React.createRef();
    this.bookValueForecast = React.createRef();
    this.divRef = React.createRef();
  }

  componentDidMount() {
    this.calcBottom();
    window.addEventListener(COMPONENT_RESIZE, this.calcBottom);
  }

  componentWillUnmount() {
    window.removeEventListener(COMPONENT_RESIZE, this.calcBottom);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.valuationStock.organCode !== this.state.organCode) {
      let estimatedBookValue = nextProps.valuationStock.estimatedBookValue;
      let bookValueForecast = nextProps.valuationStock.forcastBookValue;
      this.setState({
        ...this.state,
        eoyStockPrice: '',
        ennOfNextYearStockPrice: '',
        estimateBookValuedEOY: estimatedBookValue ? estimatedBookValue : 0,
        bookValueForecast: bookValueForecast ? bookValueForecast : 0,
        infoError: '',
        organCode: nextProps.valuationStock.organCode,
      });
      this.calcBottom();
    }
  }

  calcBottom = () => {
    if (!this.divRef.current.closest('.lm_stack')) {
      return;
    }
    const bottom = this.divRef.current
      .closest('.lm_stack')
      .getBoundingClientRect().bottom;
    this.setState({
      bottom,
    });
  };

  changeValueInput = (value, refInput) => {
    let infoError = '';

    if (value.length > 8) {
      return;
    }

    if (value.length > 0) {
      const parsedValue = parseIntComma(value);
      if (typeof parsedValue === 'number') {
        if (refInput === this.estimateBookValuedEOY) {
          this.setState({
            estimateBookValuedEOY: formatTextFloat(parseIntComma(value), 0),
          });
        } else {
          this.setState({
            bookValueForecast: formatTextFloat(parseIntComma(value), 0),
          });
        }

        return;
      }

      if (!value.match(/^[+-]?([0-9]+[.])?[0-9]+$/)) {
        if (refInput === this.estimateBookValuedEOY) {
          this.setState({
            estimateBookValuedEoyValidate: false,
            estimateBookValuedEoyError: Const.errorInput.inputCharacter,
            estimateBookValuedEOY: formatTextFloat(parseIntComma(value), 0),
            infoError,
            eoyStockPrice: '',
            ennOfNextYearStockPrice: '',
          });
        } else {
          this.setState({
            bookValueForecastValidate: false,
            bookValueForecastError: Const.errorInput.inputCharacter,
            bookValueForecast: formatTextFloat(parseIntComma(value), 0),
            infoError,
            eoyStockPrice: '',
            ennOfNextYearStockPrice: '',
          });
        }
        return;
      }
    }

    if (refInput === this.estimateBookValuedEOY) {
      this.setState({
        estimateBookValuedEOY: value
          ? formatTextFloat(parseIntComma(value), 0)
          : value,
        estimateBookValuedEoyValidate: true,
        estimateBookValuedEoyError: '',
      });
    } else {
      this.setState({
        bookValueForecast: value
          ? formatTextFloat(parseIntComma(value), 0)
          : value,
        bookValueForecastValidate: true,
        bookValueForecastError: '',
      });
    }
  };

  changePbMultiple(value) {
    this.setState({ pbMultiple: value });
  }

  validatePB(estimateBookValuedEOY, bookValueForecast, pbMultiple) {
    let infoError = '';
    if (estimateBookValuedEOY.length <= 0) {
      infoError = 'valuation.errorPB.estimateBookValuedEOYError';
      this.setState({
        infoError,
        eoyStockPrice: '',
        ennOfNextYearStockPrice: '',
      });
    } else if (bookValueForecast.length <= 0) {
      infoError = 'valuation.errorPB.bookValueForecastError';
      this.setState({
        infoError,
        eoyStockPrice: '',
        ennOfNextYearStockPrice: '',
      });
    } else if (pbMultiple === null) {
      infoError = 'valuation.errorPB.pbMultiple';
      this.setState({
        infoError,
        eoyStockPrice: '',
        ennOfNextYearStockPrice: '',
      });
    } else {
      this.setState({ infoError: '' });
    }
    return infoError;
  }

  calculatePB = () => {
    const { averagePB } = this.props;
    const estimateBookValuedEOY = parseIntComma(
      this.estimateBookValuedEOY.current.value,
    );
    const bookValueForecast = parseIntComma(
      this.bookValueForecast.current.value,
    );
    const pbMultiple = averagePB;

    let infoError = this.validatePB(
      estimateBookValuedEOY,
      bookValueForecast,
      pbMultiple,
    );
    if (infoError !== '') {
      return;
    }

    const eoyStockPrice = pbMultiple * estimateBookValuedEOY;
    const ennOfNextYearStockPrice = pbMultiple * bookValueForecast;
    this.setState({
      eoyStockPrice: formatTextFloat(eoyStockPrice).slice(0, -3),
      ennOfNextYearStockPrice: formatTextFloat(ennOfNextYearStockPrice).slice(
        0,
        -3,
      ),
      estimateBookValuedEOY: checkZerroInputValuationTool(
        estimateBookValuedEOY,
      ),
      bookValueForecast: checkZerroInputValuationTool(bookValueForecast),
    });
  };

  renderLeftInfoFields = () => {
    const { valuationStock, averagePB } = this.props;
    const numOnePB = I18n.t('valuation.methodPB.numOne');
    const numOneLast = I18n.t('valuation.methodPB.numOneLast');
    const numTwoFirstPB = I18n.t('valuation.methodPB.numTwoFirst');
    const numTwoLastPB = I18n.t('valuation.methodPB.numTwoLast');

    const numThreeFirstPB = I18n.t('valuation.methodPB.numThreeFirst');
    const numThreeLastPB = I18n.t('valuation.methodPB.numThreeLast');

    const numFourPB = I18n.t('valuation.methodPB.numFour');

    const currentBookValue = formatTextFloat(valuationStock.rtd7, 0);
    const {
      estimateBookValuedEOY,
      bookValueForecast,
      estimateBookValuedEoyValidate,
      bookValueForecastValidate,
      estimateBookValuedEoyError,
      bookValueForecastError,
      bottom,
    } = this.state;

    return (
      <>
        <div className="after-div-right">
          <span>{numOnePB}</span>
          <input className="input-method" disabled value={currentBookValue} />
          <span>{numOneLast}</span>
        </div>

        <div className="after-div-right" style={{ display: 'inherit' }}>
          <span>{numTwoFirstPB}</span>
          <div className="wrap-input-error">
            <input
              className="input-method"
              value={
                estimateBookValuedEOY
                  ? formatTextFloat(estimateBookValuedEOY, 0)
                  : estimateBookValuedEOY
              }
              onChange={e =>
                this.changeValueInput(
                  e.target.value,
                  this.estimateBookValuedEOY,
                )
              }
              ref={this.estimateBookValuedEOY}
              disabled={!bookValueForecastValidate}
            />
            {estimateBookValuedEoyValidate || (
              <InputError
                message={I18n.t(`valuation.${estimateBookValuedEoyError}`)}
              />
            )}
          </div>
          <i
            className="icon-edit2 margin-icon"
            onClick={() => this.estimateBookValuedEOY.current.select()}
          />
          <span>{numTwoLastPB}</span>
        </div>

        <div className="after-div-right" style={{ display: 'inherit' }}>
          <span>{numThreeFirstPB}</span>
          <div className="wrap-input-error">
            <input
              className="input-method"
              ref={this.bookValueForecast}
              value={
                bookValueForecast
                  ? formatTextFloat(bookValueForecast, 0)
                  : bookValueForecast
              }
              onChange={e =>
                this.changeValueInput(e.target.value, this.bookValueForecast)
              }
              disabled={!estimateBookValuedEoyValidate}
            />
            {bookValueForecastValidate || (
              <InputError
                message={I18n.t(`valuation.${bookValueForecastError}`)}
              />
            )}
          </div>
          <i
            className="icon-edit2 margin-icon"
            onClick={() => this.bookValueForecast.current.select()}
          />
          <span>{numThreeLastPB}</span>
        </div>

        <div className="after-div-right" style={{ display: 'inherit' }}>
          <span>{numFourPB}</span>
          <input
            className="input-method"
            type="number"
            value={averagePB === null ? '' : averagePB}
            disabled
          />
          <div style={{ position: 'relative' }}>
            <Icon2 bottom={bottom} type={`P/B`} />
          </div>
        </div>
      </>
    );
  };

  renderCalculationResult = () => {
    const {
      infoError,
      eoyStockPrice,
      ennOfNextYearStockPrice,
      estimateBookValuedEoyValidate,
      bookValueForecastValidate,
    } = this.state;

    const isValidate =
      !estimateBookValuedEoyValidate || !bookValueForecastValidate;

    return (
      <CalculateResult
        infoError={infoError}
        eoyStockPrice={eoyStockPrice}
        ennOfNextYearStockPrice={ennOfNextYearStockPrice}
        numOneFirstResult={'valuation.resultPB.numOneFirst'}
        numOneLastResult={'valuation.resultPB.numOneLast'}
        numTwoFirstResult={'valuation.resultPB.numTwoFirst'}
        numTwoLastResult={'valuation.resultPB.numTwoLast'}
        isValidate={isValidate}
        calculate={this.calculatePB}
      />
    );
  };

  render() {
    return (
      <>
        <div className="right-method">
          <HeaderMethod
            title={'P/B'}
            keyRecommend={ConstVal.recommendMethod.pb}
            tooltipTitle={I18n.t('valuation.tooltipInfo.pb')}
          />
          {this.renderLeftInfoFields()}
        </div>

        <div ref={this.divRef}>{this.renderCalculationResult()}</div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    valuationStock: state[REDUCER_NAME].valuationStock,
    averagePB: state[REDUCER_NAME].averagePB,
  };
};

export default connect(mapStateToProps)(PB);
